"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecursiveValidator = void 0;
const validator_1 = require("../base/validator");
const validator_2 = require("../required/validator");
class RecursiveValidator extends validator_1.BaseValidator {
    constructor() {
        super(...arguments);
        this.type = 'recursive';
    }
    required() {
        return new validator_2.RequiredValidator(this);
    }
    toSchema(traverser) {
        return {
            $ref: `#/definitions/${traverser.currentSchemaName}`,
            ...this.getJsonSchemaObject(traverser),
        };
    }
    clone(clean = false) {
        return super.setupClone(clean, new RecursiveValidator());
    }
}
exports.RecursiveValidator = RecursiveValidator;
